export const DATE_FORMAT = 'MM/DD/YYYY';
export const DATE_TIME_FORMAT = 'MM/DD/YYYY HH:mm';
export const DATE_TIME_FORMAT_12_HOUR = 'MM/DD/YYYY hh:mm A';
export const DATE_FORMAT_WITH_MONTH_NAME = 'DD MMMM YYYY';
export const DATE_FORMAT_YYYY_MM_DD = 'YYYY-MM-DD';

export const TIME_FORMAT_HH_mm_ss = 'HH:mm:ss';
